import styled from "styled-components"
import { Background } from "./InputV3.styles"

export { Wrapper } from "./InputV3.styles"
export {
  ToggleLabelContainer,
  ToggleContent,
  ToggleInput,
  ToggleLabel,
} from "./Toggle.styles"

export const ToggleContainer = styled(Background)`
  display: flex;
  align-items: center;
  min-height: auto;
  padding: 0;
  background: transparent;
  border: 0;
`
